import { render, staticRenderFns } from "./uploader.vue?vue&type=template&id=5a946d8f"
import script from "./uploader.vue?vue&type=script&lang=js"
export * from "./uploader.vue?vue&type=script&lang=js"
import style0 from "./uploader.vue?vue&type=style&index=0&id=5a946d8f&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a946d8f')) {
      api.createRecord('5a946d8f', component.options)
    } else {
      api.reload('5a946d8f', component.options)
    }
    module.hot.accept("./uploader.vue?vue&type=template&id=5a946d8f", function () {
      api.rerender('5a946d8f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uploader/uploader.vue"
export default component.exports